import React, { lazy } from 'react';
import { withLoadingAndErrorStates } from '@guildeducationinc/mfe-utils';
import { logDataDogError } from '@src/utilities/datadog';

const ProgramCardProviderRemote = lazy(
	() =>
		import(/* webpackChunkName: "remote/ProgramCardProvider" */ 'CatalogTools/ProgramCardProvider')
);

export const ProgramCardProvider = withLoadingAndErrorStates({
	component: ProgramCardProviderRemote,
	errorAs: (error, componentStack) => {
		logDataDogError(error, 'ProgramCardProviderRemoteError', {
			componentStack,
		});
		return <></>;
	},
});
